import React from "react";

import { reais } from "../../ofertas-do-dia/admin/formato";
import { formatarQtd } from "../../../lib/unidadeVenda";

export default function TabelaLugares({ lugares }) {
  return (
    <section className="rounded-xl border bg-card p-4 sm:p-5" data-e2e="sugestoes-por-lugar">
      <h3 className="font-semibold">Onde as sugestões vendem</h3>
      <p className="text-xs text-muted-foreground mb-3">Cada lugar do cardápio em que o cliente vê as sugestões.</p>
      <div className="overflow-x-auto">
        <table className="w-full text-sm">
          <thead>
            <tr className="text-left text-[11px] uppercase tracking-wide text-muted-foreground border-b">
              <th className="py-2 pr-3 font-semibold">Lugar</th>
              <th className="py-2 px-2 font-semibold text-right">Exibidas</th>
              <th className="py-2 px-2 font-semibold text-right">Adicionadas</th>
              <th className="py-2 px-2 font-semibold text-right">Vendidas</th>
              <th className="py-2 pl-2 font-semibold text-right">Receita extra</th>
            </tr>
          </thead>
          <tbody className="tabular-nums">
            {(lugares || []).map((l) => (
              <tr key={l.lugar} className="border-b last:border-0">
                <td className="py-2 pr-3 font-medium">{l.rotulo}</td>
                <td className="py-2 px-2 text-right">{l.exibidas}</td>
                <td className="py-2 px-2 text-right">{l.adicionadas}</td>
                <td className="py-2 px-2 text-right">{formatarQtd(l.vendidos, null)}</td>
                <td className="py-2 pl-2 text-right font-semibold">{reais(l.receita)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </section>
  );
}
